/* src/app/modules/shared/components/column/column-size/column-size.component.scss */
app-column-size {
  display: contents;
}
/*# sourceMappingURL=column-size.component.css.map */
